import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import Subscription from '../../models/Subscription';

async function addUserToSubscription(
  subscription: Subscription,
  auth: Authentication,
  email: string
): Promise<any> {
  try {
    return await HttpClient.put('/subscription/user/add', {}, auth.token, {
      'x-api-key': subscription.apiKey,
      'x-user-uid': auth.id,
      'x-user-email': email,
    });
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new AddUserToSubscriptionStatusFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new AddUserToSubscriptionStatusFailure(e.message);
    }
  }
}

export class AddUserToSubscriptionStatusFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default addUserToSubscription;
